import { getInternalKeyForFavouriteDescriptor } from '../util.get-internal-key.js';

function selectIsFavourite(target) {
  return data => data?.some(it => getInternalKeyForFavouriteDescriptor(it) === getInternalKeyForFavouriteDescriptor(target)) ?? false;
}

export { selectIsFavourite };
//# sourceMappingURL=selector.is-favourite.js.map
